// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/media.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message fingertip.common.type.v1.Media
 */
export const Media = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.Media",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "alt_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "focal_point_x", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "focal_point_y", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "gaussian_blur", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "asset_bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "asset_src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "asset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "asset_file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "unsplash_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "unsplash_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "unsplash_search_term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "giphy_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "giphy_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "giphy_search_term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "custom_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "blur_data_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "unsplash_attribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "brandfetch_search_term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "brandfetch_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "background_color2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "crop_x", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 26, name: "crop_y", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 27, name: "crop_w", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 28, name: "crop_h", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 29, name: "overlay_background", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "icons8_search_term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "icons8_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "icons8_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "canva_design_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.MediaValue
 */
export const MediaValue = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.MediaValue",
  () => [
    { no: 1, name: "media", kind: "message", T: Media },
  ],
);

